import React from 'react';

import useReduceStore from 'hooks/ReduceStoreHook';

import ProductStore from 'stores/ProductStore';
import HttpService from 'service/HttpService';

import AppConstants from 'AppConstants';

import ProductList from 'views/product/ProductList';
import Radium from 'radium';
import { Formik } from 'formik';
import {RGForm, ComboBox} from 'views/FormElements';

import AdminDashboardTabs from 'views/admin/AdminDashboardTabs';
import SetoCanvasPage from 'pages/SetoCanvasPage';

const COMOBO_OPTIONS = [{label: 'Pending Approval', value: AppConstants.PRODUCT_STATE.PENDING_APPROVAL},
								{label: 'Approved', value: AppConstants.PRODUCT_STATE.APPROVED},
								{label: 'Unpublished', value: AppConstants.PRODUCT_STATE.UNPUBLISHED}
							];

const Form = Radium((props) => {
	return (<div style={{width: '40%', '@media (max-width: 770px)': {width: '100%'}}}>
				<RGForm style={{display: 'flex', flexDirection: 'row', padding: '15px 20px'}}>

					<h3 style={{margin: '0 10px 0 0'}}>Design State</h3>
					
					<ComboBox name="productState" value={props.values.productState} 
								options={COMOBO_OPTIONS} clearable={false}
								style={{flexGrow: '1', margin: '0'}}/>											
				</RGForm>
			</div>)
});

function FormikForm(formikProps) {
	const productState = formikProps.values.productState;
	const allProducts = useReduceStore(ProductStore, (store) => store.getAllProducts(productState), 
									() => HttpService.getAllProducts(productState), [productState]);
	return <div>
				<Form {...formikProps} />
				<ProductList products={allProducts} productViewMode={"both"} />
		</div>
}


function ProductsDashboardPage(props) {
	return (<SetoCanvasPage title="Products Dashboard | Seto Canvas" id="productsDashboardPage">
					<AdminDashboardTabs active="products">
						<Formik initialValues={{productState: AppConstants.PRODUCT_STATE.PENDING_APPROVAL}} 
								onSubmit={() => {}}
								render={(formikProps) => {
									return <FormikForm {...formikProps} />
								}} />

					</AdminDashboardTabs>
				</SetoCanvasPage>
			);
}

export default Radium(ProductsDashboardPage);



// WEBPACK FOOTER //
// ./src/pages/admin/ProductsDashboardPage.js